import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import routes from './routes'

const router = createRouter({
    history: createWebHashHistory(),
    routes
})
router.beforeEach((to, from, next) => {
    window.scrollTo(0,0); //打开页面默认是顶部开始
        // document.title = `${to.meta.title}`;
        const role = localStorage.getItem('accessToken');
        if (!role && to.path == '/personalCenter' || !role && to.path == '/theProjectToMakeAnAppointment') {
            next('/theLogin');
        } else {
            next();
        }
    });
export default router